export default "__VITE_ASSET__df84bf67__"